import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { CompanySetting } from '../../company-setting';
import { PtoPolicyAssignment } from '../../data-services/pto-policy/assignment';
import { PtoPolicySetup } from '../../data-services/pto-policy/setup';
import { IGroup } from '../../groups/IGroups';
import { SelectItem, SortEvent, Table } from '../../shared';
import { DisplayErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-assignment-presenter',
    templateUrl: './assignment-presenter.component.html',
    styleUrls: ['./assignment-presenter.component.scss'],
    standalone: false
})
export class AssignmentPresenterComponent
    extends DisplayErrors<PtoPolicyAssignment>
    implements OnInit
{
    public editing: PtoPolicyAssignment = {} as PtoPolicyAssignment;
    clonedPolicyAssignment: { [i: string]: PtoPolicyAssignment } = {};
    @Output() SavePolicyAssignment = new ReplaySubject<any>(1);

    groupsSelectItem: SelectItem[];
    groupsInTableSelectItem: SelectItem[];
    moment: any;

    empSelection: PtoPolicyAssignment[] = [];
    groupForMultiUpdate: any;

    accrualsFilterSelectItem: SelectItem[];
    employeeFilterSelectItem: SelectItem[];
    policyFilterSelectItem: SelectItem[];

    private PolicyAssignmentSubject = new ReplaySubject<
        Array<PtoPolicyAssignment>
    >(1);
    private _policyassignment: Array<PtoPolicyAssignment>;
    @Input() set policyAssignment(value: Array<PtoPolicyAssignment>) {
        this._policyassignment = value;
        this.PolicyAssignmentSubject.next(value);

        this.accrualsFilterSelectItem = this._policyassignment.map(x => ({
            value: x.AccrualPeriod,
            label: x.AccrualPeriod
        }));
        this.accrualsFilterSelectItem = this.accrualsFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.employeeFilterSelectItem = this._policyassignment.map(x => ({
            value: x.EmployeeName,
            label: x.EmployeeName
        }));
        this.employeeFilterSelectItem = this.employeeFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );

        this.policyFilterSelectItem = this._policyassignment.map(x => ({
            value: x.PolicyTitle,
            label: x.PolicyTitle
        }));
        this.policyFilterSelectItem = this.policyFilterSelectItem.filter(
            (v, i, a) => a.findIndex(t => t.label === v.label) === i
        );
    }
    get policyAssignment(): Array<PtoPolicyAssignment> {
        return this._policyassignment;
    }

    private GroupsSubject = new ReplaySubject<Array<IGroup>>(1);
    private _groups: Array<IGroup>;
    @Input() set groups(value: Array<IGroup>) {
        this._groups = value;
        this.GroupsSubject.next(value);

        // this.groupsSelectItem = value.map(x => ({
        //     value: x.GroupID,
        //     label: x.GroupName
        // }));
        // this.groupsSelectItem = this.groupsSelectItem.filter(
        //     (v, i, a) => a.findIndex(t => t.label === v.label) === i
        // );
    }
    get groups(): Array<IGroup> {
        return this._groups;
    }

    private PolicySetupSubject = new ReplaySubject<Array<PtoPolicySetup>>(1);
    private _policysetup: Array<PtoPolicySetup>;
    @Input() set policySetup(value: Array<PtoPolicySetup>) {
        this._policysetup = value;
        this.PolicySetupSubject.next(value);

        if (value && value.length > 0) {
            this.groupsSelectItem = value.map(x => ({
                value: x.Groupid,
                label: x.PolicyTitle
            }));
            this.groupsSelectItem = this.groupsSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );

            this.groupsInTableSelectItem = value.map(x => ({
                value: x.Groupid,
                label: x.PolicyTitle
            }));
            this.groupsInTableSelectItem.unshift({
                label: '-- Unassign Policy --',
                value: null
            });
            this.groupsInTableSelectItem = this.groupsInTableSelectItem.filter(
                (v, i, a) => a.findIndex(t => t.label === v.label) === i
            );
        }
    }
    get policySetup(): Array<PtoPolicySetup> {
        return this._policysetup;
    }

    private CompanySettingsSubject = new ReplaySubject<Array<CompanySetting>>(
        1
    );
    private _companysettings: Array<CompanySetting>;
    @Input() set companySettings(value: Array<CompanySetting>) {
        this._companysettings = value;
        this.CompanySettingsSubject.next(value);
    }
    get companySettings(): Array<CompanySetting> {
        return this._companysettings;
    }

    @Input() userInfo: IUserInfo;
    @Input() isQBO: boolean;

    @Output() UpdateCompanySetting = new ReplaySubject<any>(1);
    @ViewChild('EmployeeTable', { static: true }) EmployeeTable: Table;

    constructor(private log: LoggingService) {
        super();
        this.moment = moment;
    }

    ngOnInit(): void {}

    onEditInit($event: { data: PtoPolicyAssignment }) {
        this.editing = { ...$event.data };
    }

    onRowEditInit(rowData: PtoPolicyAssignment) {
        this.clonedPolicyAssignment[rowData.Policyid] = { ...rowData };
        this.editing = rowData;
        this.log.verbose('onRowEditInit');
    }

    onRowEditSave(rowData: PtoPolicyAssignment) {
        this.SavePolicyAssignment.next(rowData);
        delete this.clonedPolicyAssignment[rowData.Policyid];
        delete this.editing;
        this.log.verbose('onRowEditSave');
    }

    onRowEditCancel(item: PtoPolicyAssignment) {
        delete this.clonedPolicyAssignment[item.Policyid];
        delete this.editing;
        this.log.verbose('onRowEditCancel');
    }

    empMultiUpdate() {
        if (this.empSelection.length > 0) {
            this.empSelection.forEach(emp => {
                emp.Groupid = this.groupForMultiUpdate;
                this.SavePolicyAssignment.next(emp);
            });
            this.empSelection = [];
        }
    }

    findGroupName(rowData) {
        let groupName;
        if (this.groups.length > 0) {
            if (this.groups.find(x => x.GroupID == rowData.Groupid) != null) {
                groupName = this.groups.find(
                    x => x.GroupID == rowData.Groupid
                ).GroupName;
                return groupName;
            } else {
                return '';
            }
        }
    }

    checkForOverrideMsg(rowData) {
        if (rowData.OverrideMsg != null) {
            return true;
        } else {
            return false;
        }
    }

    onCheckboxChange($event) {
        this.UpdateCompanySetting.next($event.checked);
    }

    customSort(event: SortEvent): void {
        if (!event?.data?.length || !event.field) {
            return;
        }
        const field = event.field;
        const order = event.order ?? 1;
        event.data.sort((a, b) => {
            const left = a?.[field];
            const right = b?.[field];
            const result =
                field === 'HireDate'
                    ? this.compareHireDates(left, right)
                    : this.compareValues(left, right);
            return result * order;
        });
    }

    private compareHireDates(left: unknown, right: unknown): number {
        const leftTime = this.hireDateSortValue(left);
        const rightTime = this.hireDateSortValue(right);
        if (leftTime == null && rightTime == null) {
            return this.compareValues(left, right);
        }
        if (leftTime == null) {
            return -1;
        }
        if (rightTime == null) {
            return 1;
        }
        return leftTime - rightTime;
    }

    private hireDateSortValue(value: unknown): number | null {
        if (value == null || value === '') {
            return null;
        }
        const parsed = moment(value as Date | string);
        return parsed.isValid() ? parsed.startOf('day').valueOf() : null;
    }

    private compareValues(left: any, right: any): number {
        if (left == null && right != null) {
            return -1;
        }
        if (left != null && right == null) {
            return 1;
        }
        if (left == null && right == null) {
            return 0;
        }
        if (typeof left === 'string' && typeof right === 'string') {
            return left.localeCompare(right);
        }
        if (left < right) {
            return -1;
        }
        if (left > right) {
            return 1;
        }
        return 0;
    }

    tableFilter($event, type) {
        if (type == 'policy') {
            this.EmployeeTable.filter($event.value, 'PolicyTitle', 'in');
        }
        if (type == 'employee') {
            this.EmployeeTable.filter($event.value, 'EmployeeName', 'in');
        }
        if (type == 'accruals') {
            this.EmployeeTable.filter($event.value, 'AccrualPeriod', 'in');
        }
    }
}
